import { render, staticRenderFns } from "./TransportTankAlarm.vue?vue&type=template&id=bafa3a32&scoped=true&"
import script from "./TransportTankAlarm.vue?vue&type=script&lang=js&"
export * from "./TransportTankAlarm.vue?vue&type=script&lang=js&"
import style0 from "./TransportTankAlarm.vue?vue&type=style&index=0&id=bafa3a32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafa3a32",
  null
  
)

export default component.exports